import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import OurServices from './components/OurServices'

function Services() {
  useEffect(() => {
    document.title = 'Agência Dorac - Serviços'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <OurServices />
      <Footer />
    </main>
  )
}

export default Services
